import { Box } from "@mui/material";
import StartStep from "./StartStep";
import EndStep from "./EndStep";
import LineStep from "./LineStep";
import { IorderInfo } from "../..";
import { convertToJalali } from "../../../../../../../../../../utils/functions";

export default function ProgressContent(props: IorderInfo) {
  const { operatorInfo } = props;

  console.log(operatorInfo, "===========");

  return (
    <Box
      sx={{
        backgroundColor: "bgColor.grey100",
        display: "flex",
        paddingBottom: "8px",
        borderRadius: "8px",
        paddingX: "6px",
        gap: "3px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          paddingY: "6px",
        }}
      >
        <StartStep
          status={2}
          badg="تکمیل شد"
          date={
            operatorInfo &&
            operatorInfo.license.insertDateTime &&
            convertToJalali(operatorInfo.license.insertDateTime).split(" ")[1]
          }
          title="صدور مجوز"
        />
        <LineStep />
        <StartStep status={1} title="صدور حواله" />
        <LineStep status={1} />
        <StartStep status={0} title="صدور بارنامه" />
        <LineStep status={0} />
        <StartStep status={0} title="بارگیری از مبدا" />
        <LineStep status={0} />
        <StartStep status={0} title="در مسیر مقصد" />
        <EndStep status={0} title="تحویل بار در مقصد" />
      </Box>
      {/* <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          // border: "1px solid gray",
          paddingTop: "8px",
        }}
      >
        <StepDetails badg="تکمیل شد" date="1402/12/05" title="صدور مجوز" />
        <StepDetails title="صدور حواله" />
        <StepDetails title="صدور بارنامه" />
        <StepDetails title="بارگیری از مبدا" />
        <StepDetails title="در مسیر مقصد" />
        <StepDetails title="تحویل بار در مقصد" />
      </Box> */}
    </Box>
  );
}
